module.exports = __webpack_public_path__ + "static/img/Angus-Crichton.c7e2994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Angus-Crichton.jpg
// module id = 1UvT
// module chunks = 0